<div class="modal-body">
  <h5>
    Are you sure that you want to delete the note(s) for the selected
    transaction(s)?
  </h5>
</div>
<div class="modal-footer">
  <button nf-button (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="delete" ngbAutoFocus (click)="delete()">
    Delete Note(s)
  </button>
</div>
